/**
 * Defines an Agent on Bkper.
 *
 * An Agent represents an entity (such as an App or Bot) that interacts with Bkper, executing actions on behalf of users.
 *
 * @public
 */
export class Agent {
    constructor(payload) {
        this.payload = payload || {};
    }
    /**
     * Gets the wrapped plain JSON object.
     *
     * @returns The wrapped plain json object
     */
    json() {
        return Object.assign({}, this.payload);
    }
    /**
     * Gets the Agent universal identifier.
     *
     * @returns The Agent universal identifier
     */
    getId() {
        return this.payload.id;
    }
    /**
     * Gets the Agent name.
     *
     * @returns The Agent name
     */
    getName() {
        return this.payload.name;
    }
    /**
     * Gets the Agent logo URL.
     *
     * @returns The Agent logo url
     */
    getLogoUrl() {
        return this.payload.logo;
    }
    /**
     * Gets the Agent logo URL in dark mode.
     *
     * @returns The Agent logo url in dark mode
     */
    getLogoUrlDark() {
        return this.payload.logoDark;
    }
}
//# sourceMappingURL=Agent.js.map